<template>
  <div>
    <v-text-field
      v-model.trim="actions.rf_settings_pin_to_selector"
      variant="outlined"
      density="compact"
      persistentPlaceholder
      hideDetails
      label="Anchor CSS selector"
      placeholder="#checkout-btn"
    />
    <div class="v-field v-field--active v-field--variant-outlined mt-4">
      <div class="v-field__field py-3">
        <div
          class="mx-auto grid w-fit grid-cols-[20px_60px_30px_30px_30px_60px_20px] grid-rows-[20px_30px_30px_30px_30px_30px_20px] gap-1 py-2"
        >
          <div
            class="text-grey-1 border-grey-3 col-start-3 col-end-6 row-start-3 row-end-6 flex items-center justify-center rounded border-2 border-dashed text-xs font-semibold"
          >
            Anchor
          </div>
          <div
            class="text-white-1 rounded bg-blue-50 px-2 py-1 text-xs whitespace-nowrap"
            :class="tooltipClass"
          >
            Prompt
          </div>
          <button
            v-for="dot in POSITION_DOTS"
            :key="dot.value"
            type="button"
            :title="dot.value"
            :aria-label="dot.value"
            :class="[
              dot.pos,
              'size-4 place-self-center rounded-full border border-blue-50',
              actions.rf_settings_pin_to_position === dot.value ? 'bg-blue-50' : 'bg-transparent',
            ]"
            @click="actions.rf_settings_pin_to_position = dot.value"
          />
        </div>
      </div>
      <div class="v-field__outline">
        <div class="v-field__outline__start"></div>
        <div class="v-field__outline__notch">
          <label class="v-label v-field-label v-field-label--floating">Pin position</label>
        </div>
        <div class="v-field__outline__end"></div>
      </div>
    </div>
    <v-select
      v-model="actions.rf_settings_pin_to_scroll"
      class="mt-4"
      variant="outlined"
      hideDetails
      density="compact"
      label="Scroll until prompt is:"
      :items="PIN_TO_SCROLL_OPTIONS"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";

const POSITION_DOTS = [
  { value: "top-start", pos: "row-start-1 col-start-3" },
  { value: "top", pos: "row-start-1 col-start-4" },
  { value: "top-end", pos: "row-start-1 col-start-5" },
  { value: "left-start", pos: "col-start-1 row-start-3" },
  { value: "left", pos: "col-start-1 row-start-4" },
  { value: "left-end", pos: "col-start-1 row-start-5" },
  { value: "right-start", pos: "col-start-7 row-start-3" },
  { value: "right", pos: "col-start-7 row-start-4" },
  { value: "right-end", pos: "col-start-7 row-start-5" },
  { value: "bottom-start", pos: "row-start-7 col-start-3" },
  { value: "bottom", pos: "row-start-7 col-start-4" },
  { value: "bottom-end", pos: "row-start-7 col-start-5" },
];
const TOOLTIP_CELL = {
  top: "row-start-2 col-start-3 col-end-6 self-end",
  bottom: "row-start-6 col-start-3 col-end-6 self-start",
  left: "col-start-2 row-start-3 row-end-6 justify-self-end",
  right: "col-start-6 row-start-3 row-end-6 justify-self-start",
};
const TOOLTIP_ALIGN = {
  x: { start: "justify-self-start", center: "justify-self-center", end: "justify-self-end" },
  y: { start: "self-start", center: "self-center", end: "self-end" },
};

const PIN_TO_SCROLL_OPTIONS = [
  { title: "Visible", value: "nearest" },
  { title: "Top of viewport", value: "start" },
  { title: "Center of viewport", value: "center" },
  { title: "Bottom of viewport", value: "end" },
  { title: "No auto-scroll", value: "none" },
];

const props = defineProps({
  actions: { type: Object, required: true },
});

const currentPosition = computed(() => props.actions.rf_settings_pin_to_position || "bottom");
const tooltipClass = computed(() => {
  const [side, align = "center"] = currentPosition.value.split("-");
  const axis = side === "top" || side === "bottom" ? "x" : "y";
  return `${TOOLTIP_CELL[side]} ${TOOLTIP_ALIGN[axis][align]}`;
});
</script>
